// src/components/InfoCardActivities.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const InfoCardNewsContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 5% 15% 5% 15%;

  @media (max-width: 500px) {
    padding:5%;
  }

`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-top:5%;
  border-top: 1px solid #3F3F3F;
`;

const SectionTitle = styled.h2`
  
  color: #FFFFFF;
  font-weight: 700;
  font-size: 36px;
  line-height: 52px;
  letter-spacing: 0.05em;
  border-left:8px solid #FFF56A ;
  padding:0% 0% 0% 2.5%;

  @media (max-width: 500px) {
    font-size: 32px;
  }



`;

const ArrowButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  padding: 10px;
  cursor: pointer;
  margin: 1px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%; 
  width: 40px; 
  height: 40px;
  font-size:18px; 

  &:hover {
    background-color: #FFFFFF;
    color: #000000;
  }

  @media (max-width: 500px) {
    font-size: 16px;
    padding: 0px;
    margin: 0px;
    width: 30px; 
    height: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 24px; 

  @media (max-width: 500px) {
    gap: 12px;
  }
`;


const CardCarousel = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;

`;

const Card = styled.div`
  background: #1F1F1F;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2.5%;
  gap: 18px;
  color: #FFFFFF;
  margin-right:3%;
  flex: 0 0 calc(43%);


  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #EFEFEF;
    
  }

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    color: #EFEFEF;
    margin-bottom:10px;
    
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 48px;
    line-height: 41px;
    color: #FFFFFF;
    margin-bottom:10px;
    margin-top:5px;
  }

  h5 {
    color: #FFFFFF;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 35px;
    display: flex;
    align-items: flex-start;
    margin-bottom:0px;
    margin-top:0px;
    


  }

  @media (max-width: 500px) {
    
    width:150%;
    gap: 9px;
    flex: 0 0 calc(80%); /* 設定原本的寬度和間距 */
    margin-right:3%;
    padding:5%;

    h3{
      font-weight: 700;
      font-size: 24px;
      line-height: 35px;

    }

    h5{
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }

    h2{
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      margin-bottom:10px;

    }

    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 24px;
      margin-bottom:0px;
      margin-top:0px;
    }


    
  }

`;

const Subtitle = styled.h3`
  color: #FFFFFF;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
  display: flex;
  align-items: flex-start;
  margin-top:20px;
  

  @media (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom:16px;
    align-items: flex-start;
  }
`;

const ReadMoreButton = styled.button`
  background-color:transparent;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-left: auto;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    
    padding: 6px 20px;

    margin: 0 0 5% auto;

  }


  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }


`;

const Node = styled.a`
  color: #FFF56A;
  text-decoration: none;
  font-style: normal;
  font-weight: 700;
  font-size: 36px;
  line-height: 12px;
  white-space: nowrap; 
  margin-left: 0;
  margin-right: 10px;
  margin-top: 10px;

  @media (max-width: 500px) {
    font-size: 36px;
    margin-top: 4px;
    margin-right: 5px;

  }
`;


const InfoCardActivities = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardArray = [0, 1, 2, 3, 4, 5,6]; 

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, cardArray.length - 1));
  };


  const [exhibition, setExhibition] = useState([])

  const fetchExhibitionData = () => {
    fetch(`${process.env.REACT_APP_ADMIN_URL}/api/exhibition`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        setExhibition(data)
      })
  }

  useEffect(() => {
    fetchExhibitionData()
  }, [])


  return (
    <InfoCardNewsContainer>
      <SectionHeader>
        <SectionTitle>活動資訊</SectionTitle>
        <ButtonContainer>
          <ArrowButton onClick={handlePrev}>&#060;</ArrowButton>
          <ArrowButton onClick={handleNext}>&#062;</ArrowButton>
        </ButtonContainer>
      </SectionHeader>
      <CardCarousel>
        {exhibition.slice(currentIndex, currentIndex + 2).map((item, index) => (
          <Card key={index}>
            <h3>{item.title}</h3>
            <h5><Node>• </Node>{item.excerpt}</h5>
            <h2>{item.content}</h2>
            <p>展期時間：{item.exhibition_date}</p>
            <p>展期地點：{item.location}</p>
            <ReadMoreButton onClick={() => window.location.href = `${item.exhibition_link}`}>活動網站</ReadMoreButton>
          </Card>
        ))}
      </CardCarousel>
    </InfoCardNewsContainer>
  );
};

export default InfoCardActivities;
